import { Injectable } from '@angular/core';

import { InlineAddConfig, InlineAddField } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class AreaAddConfigService {
  
  getAreaConfig(): InlineAddConfig {
    return {
      modelType: 'area',
      title: 'Area',
      apiEndpoint: 'api/areas/create',
      submitButtonText: 'Save',
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'areaCode': 'code'
      },
      selectionConfig: {
        targetField: 'areaId',
        valueField: 'id',
        labelField: 'code'
      },
        hiddenData: {
        isActive: true
        },
      fields: [
        {
          name: 'code',
          label: 'Code',
          type: 'text',
          required: true,
          maxLength: 20,
          placeholder: 'Enter area code',
          size: 'half',
          isInstantData: true
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 100,
          placeholder: 'Enter area name',
          size: 'half'
        },
        {
          name: 'type',
          label: 'Type',
          type: 'radio-group',
          required: true,
          defaultValue: 0,
          options: [
            { label: 'Both', value: 0 },
            { label: 'Customer Only', value: 1 },
            { label: 'Supplier Only', value: 2 }
          ],
          size: 'full'
        },
        {
          name: 'isDefault',
          label: 'Default',
          type: 'switch',
          required: false,
          size: 'half',
          defaultValue: false
        }
      ],
      showMoreDetails: false
    };
  }
}
